import React from "react";
import styles from "./LanguageToggle.module.scss";

type Language = "ru" | "en";

interface Props {
  currentLang: Language;
  onChange: (lang: Language) => void;
}

const LanguageToggle: React.FC<Props> = ({ currentLang, onChange }) => {
  return (
    <div className={styles.toggleWrapper}>
      <div
        className={`${styles.slider} ${
          currentLang === "en" ? styles.right : ""
        }`}
      />
      <button
        className={`${styles.lang} ${
          currentLang === "ru" ? styles.active : ""
        }`}
        onClick={() => onChange("ru")}
      >
        Ru
      </button>
      <button
        className={`${styles.lang} ${
          currentLang === "en" ? styles.active : ""
        }`}
        onClick={() => onChange("en")}
      >
        En
      </button>
    </div>
  );
};

export default LanguageToggle;